module.exports = __webpack_public_path__ + "img/globe.0b3d4d84.svg";